/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ReadMessageThreadResult {
  Error = 0,
  Success = 1,
  RequestValidationFailed = 2,
  InvalidCase = 3,
}
